import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTree',
  setup(__props) {

const BasicTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/BasicTree.vue"))
const CheckTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/CheckTree.vue"))
const EditTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/EditTree.vue"))
const DragDropTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/DragDropTree.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Tree View",
      title: "Tree View"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicTree)),
        _createVNode(_unref(CheckTree)),
        _createVNode(_unref(EditTree)),
        _createVNode(_unref(DragDropTree))
      ])
    ])
  ], 64))
}
}

})